import React from 'react'
import styled from 'styled-components'
import WorkspaceItem from './WorkspaceItem/WorkspaceItem'
import {AutoSizer, List} from 'react-virtualized'
import {_L, useLocaleState} from '../../../context/LocaleContext'

const WorkspaceList = props => {
  const {onBook, user, activeFloor, availableRoomList, totalSpaces} = props

  const localeState = useLocaleState()

  const doBook = item => onBook({item, isList: true})

  const renderRow = ({index, key, style}) => {
    let row = availableRoomList[index]

    return (
      <div key={key} style={style}>
        <WorkspaceItem key={key} item={row} user={user} onBook={doBook} />
      </div>
    )
  }

  // Pass the activeFloor prop to the list to force the list to re-render when the floor
  // changes. This is required because the List uses PureComponent and performs a shallow compare
  // on the props.

  const title = `${_L({key: 'Available Space:', localeState})} ${totalSpaces}`

  let rowCount = availableRoomList.length
  return (
    <Container>
      <Title>{title}</Title>
      <ListContainer>
        <AutoSizer>
          {({width, height}) => {
            return (
              <List
                width={width}
                height={height}
                rowRenderer={renderRow}
                rowCount={rowCount}
                overscanRowCount={8}
                rowHeight={100}
                activeFloor={activeFloor}
              />
            )
          }}
        </AutoSizer>
      </ListContainer>
    </Container>
  )
}

export default WorkspaceList

const Container = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #eff0f3;
  display: flex;
  flex-direction: column;
`

const Title = styled.div`
  margin: 24px 24px 0 24px;
  height: 20px;
  font-size: 18px;
  color: #a4a9b7;
  font-weight: bold;

  @media (max-width: 768px) {
    margin-left: 20px;
  }

  @media (max-width: 420px) {
    margin-left: 20px;
  }
`

const ListContainer = styled.div`
  max-width: 80%;
  height: 100%;
  margin: 24px;
  flex: 1;
  overflow-y: auto;
  box-sizing: border-box;
  border-radius: 6px;

  @media (max-width: 1500px) {
    max-width: 100%;
  }

  @media (max-width: 768px) {
    margin: 24px 20px 20px 20px;
  }

  @media (max-width: 420px) {
    margin: 20px 0 0 0;
    border-radius: 0;
  }
`
